export const segments = {
  results: 'results/operation',
};

export const routeParams = {
  operationId: 'operationId',
};

export const routes = {
  overview: (operationId: string | number, analyticType: string) => {
    return `/${segments.results}/${operationId}/${analyticType}`;
  },
};
